// extracted by mini-css-extract-plugin
export default {"NoData":"styles_NoData__a9gS4","icon":"styles_icon__xKuRM"};